/**
 * This service handle listen to network change
 * check if device online or not
 * this also listen to pause and resume in device
 */

import { Injectable, OnDestroy } from '@angular/core';
import { Network } from '@capacitor/network';
import { ToastController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkService implements OnDestroy {

  isOnline = new BehaviorSubject(false);
  listener: any;

  ngOnDestroy(): void {
    this.listener.remove();
  }

  constructor(public toastController: ToastController) {}

  /**
   * listener to check network status change and update network status
   * check if user currently connect to internet or not
   */
  public async initializeNetworkEvents() {
    this.listener = Network.addListener('networkStatusChange', (status) => {
      this.isOnline.next(status.connected);
    });
    const onlineStatus = await Network.getStatus();
    this.isOnline.next(onlineStatus.connected);
  }

  public getStatus() {
    return this.isOnline.value;
  }

}
